var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "field-selector" }, [
    _c("div", { staticClass: "field-group primitive-fields" }, [
      _c("div", { staticClass: "group-title" }, [_vm._v("Primitive Fields")]),
      _vm._v(" "),
      _c("div", { staticClass: "group-content" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Kısa metin girişi için kullanılır. İsim, başlık gibi bilgiler için uygundur.",
                },
                expression:
                  "{ content: 'Kısa metin girişi için kullanılır. İsim, başlık gibi bilgiler için uygundur.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("text")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("text_fields")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.text")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Uzun metinler, açıklamalar ve notlar için kullanılır. Birden fazla paragraf girebilirsiniz.",
                },
                expression:
                  "{ content: 'Uzun metinler, açıklamalar ve notlar için kullanılır. Birden fazla paragraf girebilirsiniz.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("long-text")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("subject")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.longText")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Sayısal değerler için kullanılır. Filtreleme ve hesaplamalarda kullanılabilir.",
                },
                expression:
                  "{ content: 'Sayısal değerler için kullanılır. Filtreleme ve hesaplamalarda kullanılabilir.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("number")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("looks_one")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.number")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Para birimi değerleri için kullanılır. Otomatik olarak para birimi formatında gösterilir.",
                },
                expression:
                  "{ content: 'Para birimi değerleri için kullanılır. Otomatik olarak para birimi formatında gösterilir.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("currency")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("attach_money"),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.currency")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Tarih ve saat bilgilerini saklamak için kullanılır. Takvim üzerinden seçim yapabilirsiniz.",
                },
                expression:
                  "{ content: 'Tarih ve saat bilgilerini saklamak için kullanılır. Takvim üzerinden seçim yapabilirsiniz.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("datetime")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("event")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.datetime")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Önceden tanımlanmış seçeneklerden birini seçmek için kullanılır. Kategori veya durum bilgisi için uygundur.",
                },
                expression:
                  "{ content: 'Önceden tanımlanmış seçeneklerden birini seçmek için kullanılır. Kategori veya durum bilgisi için uygundur.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("dropdown")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("arrow_drop_down"),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.dropdown")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Evet/Hayır tipinde bilgi saklamak için kullanılır. İşaretleme kutusunu işaretleyip kaldırabilirsiniz.",
                },
                expression:
                  "{ content: 'Evet/Hayır tipinde bilgi saklamak için kullanılır. İşaretleme kutusunu işaretleyip kaldırabilirsiniz.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("checkbox")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("check_box")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.checkbox")))]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field-group validator-fields" }, [
      _c("div", { staticClass: "group-title" }, [_vm._v("Validator Fields")]),
      _vm._v(" "),
      _c("div", { staticClass: "group-content" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Web adresleri için kullanılır. Otomatik doğrulama ile geçerli URL'leri kontrol eder.",
                },
                expression:
                  "{ content: 'Web adresleri için kullanılır. Otomatik doğrulama ile geçerli URL\\'leri kontrol eder.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("url")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("link")]),
            _vm._v(" "),
            _c("span", [_vm._v("URL")]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "E-posta adresleri için kullanılır. Otomatik doğrulama ile geçerli e-posta formatını kontrol eder.",
                },
                expression:
                  "{ content: 'E-posta adresleri için kullanılır. Otomatik doğrulama ile geçerli e-posta formatını kontrol eder.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("email")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("email")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.email")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Telefon numaraları için kullanılır. Formatlama ve doğrulama özelliği ile geçerli telefon numaralarını kontrol eder.",
                },
                expression:
                  "{ content: 'Telefon numaraları için kullanılır. Formatlama ve doğrulama özelliği ile geçerli telefon numaralarını kontrol eder.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("phone")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("phone")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.phone")))]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field-group module-fields" }, [
      _c("div", { staticClass: "group-title" }, [_vm._v("Module Fields")]),
      _vm._v(" "),
      _c("div", { staticClass: "group-content" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Kişi modülü ile ilişkilendirme için kullanılır. Mevcut kişilerden birini seçebilirsiniz.",
                },
                expression:
                  "{ content: 'Kişi modülü ile ilişkilendirme için kullanılır. Mevcut kişilerden birini seçebilirsiniz.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("contact")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("person")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("modules.contact")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Destek talebi modülüyle ilişkilendirme için kullanılır. (Henüz kullanılabilir değil)",
                },
                expression:
                  "{ content: 'Destek talebi modülüyle ilişkilendirme için kullanılır. (Henüz kullanılabilir değil)' }",
              },
            ],
            staticClass: "field-item not-implemented",
            on: {
              click: function ($event) {
                return _vm.selectField("ticket")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("confirmation_number"),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("message.ticket")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Görev modülü ile ilişkilendirme için kullanılır. Mevcut görevlerden birini seçebilirsiniz.",
                },
                expression:
                  "{ content: 'Görev modülü ile ilişkilendirme için kullanılır. Mevcut görevlerden birini seçebilirsiniz.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("task")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("assignment")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("message.task")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Etkinlik modülüyle ilişkilendirme için kullanılır. (Henüz kullanılabilir değil)",
                },
                expression:
                  "{ content: 'Etkinlik modülüyle ilişkilendirme için kullanılır. (Henüz kullanılabilir değil)' }",
              },
            ],
            staticClass: "field-item not-implemented",
            on: {
              click: function ($event) {
                return _vm.selectField("event")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("event")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("message.event")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Kullanıcı modülü ile ilişkilendirme için kullanılır. Sistemdeki kullanıcılardan birini seçebilirsiniz.",
                },
                expression:
                  "{ content: 'Kullanıcı modülü ile ilişkilendirme için kullanılır. Sistemdeki kullanıcılardan birini seçebilirsiniz.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("user")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("support_agent"),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("message.user")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Sohbet/Görüşme modülü ile ilişkilendirme için kullanılır. Mevcut görüşmelerden birini seçebilirsiniz.",
                },
                expression:
                  "{ content: 'Sohbet/Görüşme modülü ile ilişkilendirme için kullanılır. Mevcut görüşmelerden birini seçebilirsiniz.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("conversation")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("message")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("Chat")))]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field-group metadata-fields" }, [
      _c("div", { staticClass: "group-title" }, [_vm._v("Meta Fields")]),
      _vm._v(" "),
      _c("div", { staticClass: "group-content" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Kayıt benzersiz kimlik numarasını gösteren otomatik alan. Her kayıt için sistem tarafından atanır.",
                },
                expression:
                  "{ content: 'Kayıt benzersiz kimlik numarasını gösteren otomatik alan. Her kayıt için sistem tarafından atanır.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("record_id")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("tag")]),
            _vm._v(" "),
            _c("span", [_vm._v("Record ID")]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Kaydın oluşturulma tarih ve saatini gösteren otomatik alan. Sistem tarafından atanır.",
                },
                expression:
                  "{ content: 'Kaydın oluşturulma tarih ve saatini gösteren otomatik alan. Sistem tarafından atanır.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("record_created_at")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("add_circle_outline"),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("Record Created At")]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Kaydın son güncellenme tarih ve saatini gösteren otomatik alan. Her güncellemede sistem tarafından yenilenir.",
                },
                expression:
                  "{ content: 'Kaydın son güncellenme tarih ve saatini gösteren otomatik alan. Her güncellemede sistem tarafından yenilenir.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("record_updated_at")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("update")]),
            _vm._v(" "),
            _c("span", [_vm._v("Record Updated At")]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Kaydı oluşturan kullanıcıyı gösteren otomatik alan. Sistem tarafından atanır.",
                },
                expression:
                  "{ content: 'Kaydı oluşturan kullanıcıyı gösteren otomatik alan. Sistem tarafından atanır.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("record_created_by")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("person_add")]),
            _vm._v(" "),
            _c("span", [_vm._v("Record Created By")]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Kaydı son güncelleyen kullanıcıyı gösteren otomatik alan. Her güncellemede sistem tarafından yenilenir.",
                },
                expression:
                  "{ content: 'Kaydı son güncelleyen kullanıcıyı gösteren otomatik alan. Her güncellemede sistem tarafından yenilenir.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("record_updated_by")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("person_outline"),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("Record Updated By")]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field-group file-fields" }, [
      _c("div", { staticClass: "group-title" }, [_vm._v("File Fields")]),
      _vm._v(" "),
      _c("div", { staticClass: "group-content" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Herhangi bir dosya türünü yüklemek ve saklamak için kullanılır. Belgeler, arşivler vb. için uygundur.",
                },
                expression:
                  "{ content: 'Herhangi bir dosya türünü yüklemek ve saklamak için kullanılır. Belgeler, arşivler vb. için uygundur.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("file")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("attachment")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.file")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Resim dosyalarını yüklemek ve görüntülemek için kullanılır. Resimler otomatik olarak küçük resim olarak gösterilir.",
                },
                expression:
                  "{ content: 'Resim dosyalarını yüklemek ve görüntülemek için kullanılır. Resimler otomatik olarak küçük resim olarak gösterilir.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("image")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("image")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.image")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Video dosyalarını yüklemek ve oynatmak için kullanılır. Desteklenen video formatları ile çalışır.",
                },
                expression:
                  "{ content: 'Video dosyalarını yüklemek ve oynatmak için kullanılır. Desteklenen video formatları ile çalışır.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("video")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("videocam")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.video")))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  content:
                    "Ses dosyalarını yüklemek ve oynatmak için kullanılır. Desteklenen ses formatları ile çalışır.",
                },
                expression:
                  "{ content: 'Ses dosyalarını yüklemek ve oynatmak için kullanılır. Desteklenen ses formatları ile çalışır.' }",
              },
            ],
            staticClass: "field-item",
            on: {
              click: function ($event) {
                return _vm.selectField("audio")
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("audiotrack")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("tables.audio")))]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field-group special-fields" }, [
      _c("div", { staticClass: "group-title" }, [_vm._v("Special Fields")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "group-content" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: {
                    content:
                      "Yapay zeka destekli alan. Metin analizi, özetleme, sınıflandırma gibi AI işlemleri için kullanılır.",
                  },
                  expression:
                    "{ content: 'Yapay zeka destekli alan. Metin analizi, özetleme, sınıflandırma gibi AI işlemleri için kullanılır.' }",
                },
              ],
              staticClass: "field-item",
              on: {
                click: function ($event) {
                  return _vm.selectField("ai")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("auto_awesome"),
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("AI Field")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: {
                    content:
                      "Hesaplamalı alan. Diğer alanlardaki verileri kullanarak otomatik hesaplama yapar.",
                  },
                  expression:
                    "{ content: 'Hesaplamalı alan. Diğer alanlardaki verileri kullanarak otomatik hesaplama yapar.' }",
                },
              ],
              staticClass: "field-item",
              on: {
                click: function ($event) {
                  return _vm.selectField("formula")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("functions")]),
              _vm._v(" "),
              _c("span", [_vm._v("Formula")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: {
                    content:
                      "Başka bir tablodaki verileri görüntülemeye yarayan alan. İlişkili tablolardaki bilgileri gösterir.",
                  },
                  expression:
                    "{ content: 'Başka bir tablodaki verileri görüntülemeye yarayan alan. İlişkili tablolardaki bilgileri gösterir.' }",
                },
              ],
              staticClass: "field-item",
              on: {
                click: function ($event) {
                  return _vm.selectField("lookup")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("sync_alt")]),
              _vm._v(" "),
              _c("span", [_vm._v("Lookup")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: {
                    content:
                      "Otomatik artan sayı/metin alanı. Her yeni kayıt için benzersiz ve sıralı bir değer üretir.",
                  },
                  expression:
                    "{ content: 'Otomatik artan sayı/metin alanı. Her yeni kayıt için benzersiz ve sıralı bir değer üretir.' }",
                },
              ],
              staticClass: "field-item",
              on: {
                click: function ($event) {
                  return _vm.selectField("auto-increment")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("plus_one")]),
              _vm._v(" "),
              _c("span", [_vm._v("Auto Increment")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "PermissionController",
            {
              attrs: {
                permissions: ["automation.get", "table.update"],
                controller: "every",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "field-item",
                  on: { click: _vm.createAutomationButton },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("smart_button"),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("tables.automationButton"))),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: {
                    content:
                      "Başka bir tablo kaydına bağlantı kurmak için kullanılır. İlişkili kayıtları birbirine bağlar.",
                  },
                  expression:
                    "{ content: 'Başka bir tablo kaydına bağlantı kurmak için kullanılır. İlişkili kayıtları birbirine bağlar.' }",
                },
              ],
              staticClass: "field-item",
              on: {
                click: function ($event) {
                  return _vm.selectField("linked-record")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("switch_access_shortcut"),
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("Linked Record")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: {
                    content:
                      "JSON formatında veri saklamak için kullanılır. Karmaşık yapılandırılmış verileri depolamak için uygundur.",
                  },
                  expression:
                    "{ content: 'JSON formatında veri saklamak için kullanılır. Karmaşık yapılandırılmış verileri depolamak için uygundur.' }",
                },
              ],
              staticClass: "field-item",
              on: {
                click: function ($event) {
                  return _vm.selectField("json")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("code")]),
              _vm._v(" "),
              _c("span", [_vm._v("JSON")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: {
                    content:
                      "Renk seçimi ve saklama için kullanılır. Renk paleti üzerinden seçim yapabilirsiniz.",
                  },
                  expression:
                    "{ content: 'Renk seçimi ve saklama için kullanılır. Renk paleti üzerinden seçim yapabilirsiniz.' }",
                },
              ],
              staticClass: "field-item",
              on: {
                click: function ($event) {
                  return _vm.selectField("color")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("palette")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("tables.color")))]),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }